<div class="orders-container">
  <!-- Tabs -->
  <div class="tabs-container">
    <div *ngFor="let tab of tabs" 
         class="tab" 
         [class.active]="tab === activeTab"
         (click)="onTabChange(tab)">
      {{ tab }}
    </div>
  </div>

  <!-- Content Container -->
  <div class="content-container">
    <h2 class="tab-heading">{{ activeTab }}</h2>
    
    <!-- Table -->
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th *ngFor="let column of tableColumns" [style.width]="column.width">
              {{ column.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of selectedOrders" 
              (click)="showResponse(order)"
              [class.medication-order]="order.orderType == 3"
              [style.cursor]="order.orderType == 3 ? 'default' : 'pointer'">
            <td *ngFor="let column of tableColumns">
              {{ getCellValue(order, column.name) }}
            </td>
          </tr>
          <tr *ngIf="selectedOrders.length === 0">
            <td [attr.colspan]="tableColumns.length" class="no-data">
              No orders selected
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Order Button -->
    <div class="full-width">
      <button *ngIf="showOrderButton" 
            class="order-button"
            (click)="onOrderClick()">
      Order
    </button>
    <button *ngIf="isCaseEndPhase && activeTab === 'Order Sheet'" 
            class="order-button"
            (click)="onExitCaseClick()">
      Exit Case
    </button>
    </div>
  </div>
</div>

<!-- Orders Popup -->
<div class="pop-up-wrapper">
    <app-orders-popup
    [orderList]="orderList" 
    [currentCaseDay]="currentCaseDay"
    [currentCaseTime]="currentCaseTime"
    [selectedOrderIds]="selectedOrderIds"
    [cancelledOrders]="cancelledOrders"
    *ngIf="showPopup"
    (close)="onPopupClose()"
    (confirmOrders)="onOrdersConfirm($event)"
  ></app-orders-popup>
</div>

<!-- End Case Confirmation Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showCancelOrderConfirmation">
  <div class="confirmation-dialog">
    <div class="confirmation-content">
      <h3>Cancel Order</h3>
      <p>Are you sure you want to cancel this order? </p>
      <div class="confirmation-actions">
        <button class="btn-stop" (click)="closeCancelOrderConfirmation()">No</button>
        <button class="btn-continue" (click)="cancelOrder()">Yes</button>
      </div>
    </div>
  </div>
</div>

<!-- Prerequisite Order Cancellation Confirmation Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showPrerequisiteCancelConfirmation">
  <div class="confirmation-dialog cancelpre">
    <div class="confirmation-content">
      <h3>Cancel Prerequisite Order</h3>
      <p>{{ prerequisiteCancelMessage }}</p>
      <div class="confirmation-actions">
        <button class="btn-stop" (click)="closePrerequisiteCancelConfirmation()">No</button>
        <button class="btn-continue" (click)="cancelPrerequisiteOrder()">Yes</button>
      </div>
    </div>
  </div>
</div>

<!-- Diagnosis Entry Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showDiagnosisDialog">
  <div class="confirmation-dialog diagnosis-dialog">
    <div class="confirmation-content">
      <h3>Enter your diagnosis</h3>
      <div class="diagnosis-content">
        <p class="diagnosis-subtitle">Please enter your primary diagnosis only</p>
        <div class="diagnosis-input-container">
          <textarea 
            [(ngModel)]="diagnosisText" 
            class="diagnosis-textarea"
            rows="7"
            placeholder="Enter your primary diagnosis here...">
          </textarea>
        </div>
        <div class="confirmation-actions">
      </div>
      
        
        <button class="btn-continue" (click)="onDiagnosisConfirm()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Thank You Dialog -->
<div class="confirmation-dialog-overlay" *ngIf="showThankYouDialog">
  <div class="confirmation-dialog thank-you-dialog">
    <h3>CCS Module</h3>
    <div class="confirmation-content">
      <h2 class="end-of-case">End of case</h2>
      <p class="thank-you-message">Thank you for taking care of the patient.</p>
    </div>
  </div>
</div> 